import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            flexDirection: 'column',
            width: '100%',
            gap: remCalc(8),
        },
        errorText: {
            textStyle: 'body-xxsmall',
            color: 'text.danger',
        },
        unavailable: {
            textStyle: 'body-xxsmall',
            color: 'text.tertiary',
        },
        backToLookupBtn: {
            variant: 'text-button',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            justifyContent: 'flex-start',
            padding: remCalc(0),
        },
        gaps: {
            gap: remCalc(24),
            flexDirection: {base: 'column', md: 'row'},
            paddingY: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
        },
        divider: {
            // borderBottom: 'small',
            // borderStyle: 'solid',
            // borderColor: 'border.light',
            // paddingBottom: remCalc(16),
        },
        deliveryNoteText: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
    },
    variants: {
        contactUs: {
            container: {
                gap: remCalc(32),
            },
            gaps: {
                gap: [remCalc(32), remCalc(32), remCalc(32), remCalc(20)],
                paddingY: {
                    base: 0,
                    lg: 0,
                },
            },
        },
        accountForm: {
            container: {
                gap: {
                    base: remCalc(18),
                    lg: remCalc(22),
                },
            },
        },
    },
}
